import { render, staticRenderFns } from "./BaoX.vue?vue&type=template&id=691d648a"
import script from "./BaoX.vue?vue&type=script&lang=js"
export * from "./BaoX.vue?vue&type=script&lang=js"
import style0 from "./BaoX.vue?vue&type=style&index=0&id=691d648a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports